import Header from './components/Header';
import Hero from './components/Hero';
import { SectionCarousel, SectionAbout, SectionContact, SectionUpdates } from './components/SectionsGroup1';
import { SectionCards, SectionIndex, SectionFeatures, SectionComments } from './components/SectionsGroup2';
import { SectionFaq, SectionTopics, SectionMedia, SectionApp, SectionRanking } from './components/SectionsGroup3';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <SectionCarousel />
        <SectionAbout />
        <SectionContact />
        <SectionUpdates />
        <SectionCards />
        <SectionIndex />
        <SectionFeatures />
        <SectionComments />
        <SectionFaq />
        <SectionTopics />
        <SectionMedia />
        <SectionApp />
        <SectionRanking />
      </main>
      <Footer />
    </>
  );
}